import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { DEFAULT_LOCALE } from "./localesConfig";
import { parseLocaleFromPathname } from "./paths";
import { getStoredLocale, isAppPath } from "./localePreference";
import enUS from "./locales/en-US.json";
import esES from "./locales/es-ES.json";
import esMX from "./locales/es-MX.json";
import enCA from "./locales/en-CA.json";
import enGB from "./locales/en-GB.json";

/** Start in the page's language so the first render is already translated. */
const initialLocale = () => {
  if (typeof window === "undefined") return DEFAULT_LOCALE;
  const { pathname } = window.location;
  return isAppPath(pathname)
    ? getStoredLocale() ?? DEFAULT_LOCALE
    : parseLocaleFromPathname(pathname).locale;
};

void i18n.use(initReactI18next).init({
  resources: {
    "en-US": { translation: enUS },
    "es-ES": { translation: esES },
    "es-MX": { translation: esMX },
    "en-CA": { translation: enCA },
    "en-GB": { translation: enGB },
  },
  lng: initialLocale(),
  fallbackLng: DEFAULT_LOCALE,
  interpolation: { escapeValue: false },
  returnNull: false,
});

export default i18n;
